module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN: 978 1 47384 547 3"), _c('br'), _vm._v("\nPDF ISBN: 978 1 47384 550 3"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 47384 549 7"), _c('br'), _vm._v("\nPRC ISBN: 978 1 47384 548 0")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Price £9.99")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Pen & Sword Books Ltd"), _c('br'), _vm._v("47 Church Street"), _c('br'), _vm._v("Barnsley S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Telephone: 01226-734222 Fax: 01226-734438"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("© R&F Defence Publications")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The Information in this publication has been gathered from unclassified sources.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Front Cover: T Hawk UAV clearing a route of improvised explosive devices as part of the ‘Talisman’ route clearance system. (Copyright MoD 2015)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Rear Cover: Soldier manning a .50 cal heavy machine gun mounted on a Jackal 2 All Terrain Vehicle. (Copyright MoD 2015)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cbebeee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0